import { Menu, MenuButton, MenuList, MenuItem } from '@chakra-ui/react';
import { CustomMeatballIcon } from '../../../theme/icons/CustomMeatballIcon';
import BatchesCreateMoreInfo from './BatchesCreateMoreInfo';
import { useDisclosure } from '@chakra-ui/react';
import { CustomViewIcon } from '../../../theme/icons/CustomViewIcon';
import { DownloadIcon } from '@chakra-ui/icons';

interface BatchCreateInfo {
  id: string;
  name: string;
  status: string;
  csvResults?: string | null;
}

interface CellData {
  row?: {
    original: BatchCreateInfo;
  };
  original?: BatchCreateInfo;
}

interface BatchesCreateMenuProps {
  cell: CellData;
}

const BatchesCreateMenu = ({ cell }: BatchesCreateMenuProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const original: BatchCreateInfo = cell?.row?.original ??
    cell?.original ?? {
      id: '',
      name: '',
      status: '',
      csvResults: '',
    };

  return (
    <>
      <Menu>
        <MenuButton>
          <CustomMeatballIcon boxSize={6} color="secondaryDark" />
        </MenuButton>
        <MenuList>
          <MenuItem
            onClick={onOpen}
            _focus={{
              backgroundColor: 'lightGrey2',
            }}
          >
            <CustomViewIcon fontSize={18} mr={2} color="secondaryDark" />
            View Details
            <BatchesCreateMoreInfo
              isOpen={isOpen}
              onClose={onClose}
              cell={cell}
            />
          </MenuItem>
          {original?.csvResults && (
            <MenuItem
              onClick={() => {
                window.open(original?.csvResults, '_blank');
              }}
            >
              <DownloadIcon fontSize={18} mr={2} color="secondaryDark" />
              Download Results
            </MenuItem>
          )}
        </MenuList>
      </Menu>
    </>
  );
};

export default BatchesCreateMenu;
